import React from 'react';
import {Route, Routes} from "react-router-dom";
import FreeGiftList from "./FreeGiftList";
import FreeGiftRedeem from "./FreeGiftRedeem";
import FreeGiftRedeemed from "./FreeGiftRedeemed";

function FreeGiftIndex(props) {
    return (
       <Routes>
           <Route path={"/"} element={<FreeGiftList/>}/>
           <Route path={"success/:id"} element={<FreeGiftRedeemed/>}/>
           <Route path={"/:id"} element={<FreeGiftRedeem/>}/>
       </Routes>
    );
}

export default FreeGiftIndex;
